import api from "./index";

export interface CourseListenersListParams {
  id: string;
  userId?: string;
  fullName?: string;
  email?: string;
  enabled?: boolean;
  success?: boolean;
  passed?: boolean;
  createdAtMin?: Date;
  createdAtMax?: Date;
  passedAtMin?: Date;
  passedAtMax?: Date;
  registeredAtMin?: Date;
  registeredAtMax?: Date;
  sort?: "createdAt" | "passedAt";
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: CourseListenersListParams, options?: any) => {
  return api.CourseApi.listenersList(
    params.id,
    params.userId,
    params.fullName,
    params.email,
    params.enabled,
    params.success,
    params.passed,
    params.createdAtMin,
    params.createdAtMax,
    params.passedAtMin,
    params.passedAtMax,
    params.registeredAtMin,
    params.registeredAtMax,
    params.sort,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
